import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-773e4965"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "column_page" }
const _hoisted_2 = { class: "header_img" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "column_content" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "block-title" }, [
  /*#__PURE__*/_createElementVNode("span", null, "基本情况")
], -1))
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = {
  key: 0,
  class: "now_img"
}
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  key: 1,
  style: {"padding":"30px 0","text-align":"center","font-size":"14px","color":"#666"}
}
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "block-title block-title2" }
const _hoisted_12 = {
  key: 0,
  class: "van-list"
}
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "img-ctn" }
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "p_1" }
const _hoisted_17 = { class: "zymc" }
const _hoisted_18 = {
  key: 1,
  style: {"padding":"30px 0","text-align":"center","font-size":"14px","color":"#666"}
}

import { onMounted, ref, watch, onBeforeUnmount, onBeforeMount, onActivated } from "vue"
import { showImagePreview } from "vant"
import router from "@/router"
import { useRoute } from "vue-router"
import ListWithRefreshAndLazyLoad from "@/components/ListWithRefreshAndLazyLoad.vue"
import { showNotify, showLoadingToast, closeToast, showConfirmDialog } from "vant"
import { squarePageApi, resourceSectionGetApi, addFeedBackApi } from "@/api/home"
import DataList from "@/api/common"

export default /*#__PURE__*/_defineComponent({
  __name: 'column',
  setup(__props) {

const route = useRoute()
const getDataAPI = squarePageApi // 获取列表接口
const listRef: any = ref(null)
const list: any = ref([])
const params: any = ref({
  size: 10
})
const detailDatas: any = ref({})
// 获取头部图片地址
const getTopImgUrl = () => {
  var url = DataList.UpdtImagePrefix() + detailDatas.value?.topImageId
  return url
}
// 获取轮播图片预览地址
const getImg = (sfid: string) => {
  var url = DataList.UpdtImagePrefix() + sfid
  return url
}
// 照片点击预览
const openImagePreview = (images: any, index: number) => {
  console.log(images)
  var imgs: any = []
  images.map((element: any) => {
    imgs.push(DataList.UpdtImagePrefix() + element)
  })
  showImagePreview({
    images: imgs,
    showIndex: true,
    loop: false,
    closeable: true,
    startPosition: index
  })
}
// 重点成片资产获取图片地址
const getimgUrl = (item: any, num: any) => {
  var id = num == 1 ? item.imageResourceSfid : item.fmtpDetail2?.sfid || item.fmtpDetail?.sfid
  var url = DataList.UpdtImagePrefix() + id
  return url
}
const gotoDetail = (item: any) => {
  //记录浏览量
  var datas = {
    originalSfid: item.sfid,
    type: "resource"
  }
  addFeedBackApi(datas).then(() => {})
  router.push({ path: "/resource/detail", query: { id: item.sfid } })
}
// 获取详情
const getDtail = async (sfid: any) => {
  showLoadingToast({
    message: "加载中"
  })
  const formDatas = new FormData()
  formDatas.append("id", sfid)
  resourceSectionGetApi(formDatas).then((res: any) => {
    closeToast()
    if (res.code == 200) {
      detailDatas.value = res.data
      list.value = res.data?.resources || []
    } else {
      showNotify({ type: "danger", message: res.message })
    }
  })
}
onMounted(() => {
  if (route.query.sfid) {
    getDtail(route.query.sfid)
  }
})

return (_ctx: any,_cache: any) => {
  const _component_van_swipe_item = _resolveComponent("van-swipe-item")!
  const _component_van_swipe = _resolveComponent("van-swipe")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        class: "home_img",
        fit: "cover",
        src: getTopImgUrl(),
        alt: ""
      }, null, 8, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("div", {
        class: "detail_text",
        innerHTML: detailDatas.value?.baseOverview
      }, null, 8, _hoisted_6),
      _createElementVNode("div", null, [
        (detailDatas.value?.baseOverviewImageIds)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createVNode(_component_van_swipe, {
                class: "swipe-ctn",
                autoplay: 3000,
                "indicator-color": "#eeb230"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detailDatas.value.baseOverviewImageIds.split(','), (item, i) => {
                    return (_openBlock(), _createBlock(_component_van_swipe_item, {
                      key: i,
                      onClick: ($event: any) => (openImagePreview(detailDatas.value.baseOverviewImageIds.split(','), i))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("img", {
                          class: "home_img",
                          fit: "cover",
                          src: getImg(item),
                          alt: ""
                        }, null, 8, _hoisted_8)
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  }), 128))
                ]),
                _: 1
              })
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_9, "暂时没有图片信息哦~"))
      ]),
      (detailDatas.value.assets && detailDatas.value.assets.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detailDatas.value.assets, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                style: {"margin-top":"5px"}
              }, [
                _createElementVNode("p", _hoisted_11, [
                  _createElementVNode("span", null, _toDisplayString(item.displayName), 1)
                ]),
                (item.resources?.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.resources, (item2, i) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "list-item flex-column",
                          key: i,
                          onClick: ($event: any) => (gotoDetail(item2))
                        }, [
                          _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("img", {
                              src: getimgUrl(item2, '2'),
                              alt: ""
                            }, null, 8, _hoisted_15)
                          ]),
                          _createElementVNode("p", _hoisted_16, [
                            _createElementVNode("span", _hoisted_17, _toDisplayString(item2.zymc), 1)
                          ])
                        ], 8, _hoisted_13))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_18, " 暂时没有" + _toDisplayString(item.displayName) + "哦~ ", 1))
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})